<template>
    <v-stepper
            v-model="activeElementStep"
            vertical
    >
        <v-stepper-step
                :complete="activeElementStep > 1"
                step="1"
        >
            Confirm Enquiry
        </v-stepper-step>
        <v-stepper-content
                step="1"
        >
            <v-card
                    class="mb-4 elevation-0"
            >
                <p>
                    Choose <span class="font-weight-bold">Confirm</span> to <span class="font-weight-bold">accept the enquiry.</span>
                </p>
                <p>
                    Choose <span class="font-weight-bold">Decline</span> to <span class="font-weight-bold">cancel the enquiry.</span>
                </p>
                <p>
                    If <span class="font-weight-bold">Price, Departure Date or both</span> has <span class="font-weight-bold">changed</span>, choose Alternatives
                </p>
            </v-card>
            <v-btn
                    class="secondary mr-4"
                    @click="confirmBooking"
                    :disabled="isLoading"
            >
                Confirm
            </v-btn>
            <v-btn
                    class="secondary mr-4"
                    @click="declineBooking"
                    :disabled="isLoading"
            >
                Decline
            </v-btn>
            <v-btn
                    class="secondary"
                    @click="setStep(2)"
                    :disabled="isLoading"
            >
                Alternatives
            </v-btn>
        </v-stepper-content>
        <v-stepper-step
                step="2"
        >
            Alternate offer: Provide all necessary information for the ASI sales team
        </v-stepper-step>
        <v-stepper-content
                step="2"
        >
            <v-card
                    class="mb-4 elevation-0"
            >
                <form>
                    <v-container>
                        <v-row>
                            <v-col
                                    cols="6"
                            >
                                <v-select
                                        :items="alternativeOptions"
                                        v-model="alternative"
                                >
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row
                                v-if="alternative !== 'Alternative Date'"
                                no-gutters
                        >
                            <v-col>
                                <v-row
                                        class="align-center"
                                >
                                    <v-col
                                            cols="3"
                                    >
                                        Total Price
                                    </v-col>
                                    <v-col
                                            cols="3"
                                    >
                                        <v-text-field
                                                readonly
                                                label="Current Total Price"
                                                prefix="€"
                                                v-model="bookingPrice"
                                        >
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row
                                        class="align-center"
                                >
                                    <v-col
                                            cols="3"
                                    >
                                        Overall {{chargeLabel}}
                                    </v-col>
                                    <v-col
                                            cols="3"
                                    >
                                        <v-radio-group
                                                v-model="isSurcharge"
                                                row
                                        >
                                            <v-radio
                                                    label="Surcharge"
                                                    :value="true"
                                            >
                                            </v-radio>
                                            <v-radio
                                                    label="Discount"
                                                    :value="false"
                                            >
                                            </v-radio>
                                        </v-radio-group>
                                        <v-text-field
                                                :label="chargeLabel"
                                                type="number"
                                                prefix="€"
                                                :error-messages="offerPriceErrors"
                                                @input="$v.alternativeData.offerPrice.$touch()"
                                                @blur="$v.alternativeData.offerPrice.$touch()"
                                                v-model="alternativeData.offerPrice"
                                        >
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row
                                        class="align-center"
                                >
                                    <v-col
                                            cols="3"
                                            class="font-weight-bold"
                                    >
                                        New Total Price
                                    </v-col>
                                    <v-col
                                            cols="3"
                                    >
                                        <v-text-field
                                                readonly
                                                label="New Total Price"
                                                prefix="€"
                                                :value="totalOfferPrice"
                                        >
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-divider
                                class="mb-4"
                        ></v-divider>
                        <v-row
                                v-if="alternative !== 'Add Surcharge/Discount'"
                        >
                            <v-col
                                    cols="6"
                            >
                                <v-menu
                                        v-model="menus.offerDate"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                >
                                    <template
                                            v-slot:activator="{on, attrs}"
                                    >
                                        <v-text-field
                                                v-model="alternativeData.offerDate"
                                                label="New Departure Date"
                                                append-icon="mdi-calendar"
                                                readonly
                                                :error-messages="offerDateErrors"
                                                @input="$v.alternativeData.offerDate.$touch()"
                                                @blur="$v.alternativeData.offerDate.$touch()"
                                                v-bind="attrs"
                                                v-on="on"
                                        >
                                        </v-text-field>
                                    </template>
                                    <v-date-picker
                                            v-model="alternativeData.offerDate"
                                            :min="nowDate"
                                            @input="closeDateMenu"
                                    >
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                        <v-divider
                                class="mb-4"
                        ></v-divider>
                        <v-row>
                            <v-col
                                    cols="6"
                            >
                                <v-textarea
                                        label="Internal Comment for ASI"
                                        v-model="alternativeData.comment"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </v-container>
                </form>
            </v-card>
            <v-btn
                    class="secondary mr-4"
                    @click="sendOffer"
                    :disabled="isLoading"
            >
                Send ASI New offer
            </v-btn>
            <v-btn
                    text
                    @click="setStep(1)"
                    :disabled="isLoading"
            >
                Back
            </v-btn>
            <confirm-dialog ref="confirm"></confirm-dialog>
        </v-stepper-content>
    </v-stepper>
</template>

<script>
    import {SnackBarAction, SnackBarTypes} from "../../store/snackbar/types";
    import {mapActions, mapGetters} from "vuex";
    import {requiredIf} from "vuelidate/lib/validators";
    import {validationMixin} from "vuelidate";
    import {BookingsActions} from "../../store/bookings/types";
    import ConfirmDialog from "@/components/Dialog/ConfirmDialog";

    export default {
        components:{
            ConfirmDialog
        },
        mixins: [
            validationMixin,
        ],
        data: () => ({
            menus: {
                offerDate: false,
            },
            activeElementStep: 1,
            alternativeOptions: [
                'Add Surcharge/Discount',
                'Alternative Date',
                'Add Surcharge/Discount & Alternative Date',
            ],
            alternative: 'Add Surcharge/Discount',
            isSurcharge: true,
            alternativeData: {
                offerPrice: null,
                offerDate: null,
                comment: null,
            },
        }),
        validations: {
            alternativeData: {
                offerPrice: {
                    required: requiredIf(function () {
                        return this.alternative !== 'Alternative Date';
                    }),
                },
                offerDate: {
                    required: requiredIf(function () {
                        return this.alternative !== 'Add Surcharge/Discount';
                    }),
                },
            },
        },
        computed: {
            ...mapGetters({
                booking: 'bookings/booking',
                loading: 'bookings/isLoading',
            }),
            bookingPrice(){
              return this.booking.priceTotal - this.booking.flexPrice;
            },
            nowDate() {
                return new Date().toISOString();
            },
            isLoading() {
                return this.loading || this.booking === null;
            },
            chargeLabel() {
                return this.isSurcharge ? 'Surcharge' : 'Discount';
            },
            offerPriceErrors() {
                const errors = [];
                if (!this.$v.alternativeData.offerPrice.$dirty) {
                    return errors;
                }
                if (!this.$v.alternativeData.offerPrice.required) {
                    errors.push('New Price is required');
                }

                return errors;
            },
            offerDateErrors() {
                const errors = [];
                if (!this.$v.alternativeData.offerDate.$dirty) {
                    return errors;
                }
                if (!this.$v.alternativeData.offerDate.required) {
                    errors.push('New Date is required');
                }

                return errors;
            },
            totalOfferPrice() {
                let offerPrice = parseFloat(this.alternativeData.offerPrice);
                if(!this.isSurcharge) {
                    offerPrice = -offerPrice;
                }
                if(isNaN(offerPrice)) {
                    offerPrice = 0;
                }

                return parseFloat(this.bookingPrice) + offerPrice;
            },
        },
        methods: {
            ...mapActions({
                confirm: `bookings/${BookingsActions.CONFIRM}`,
                decline: `bookings/${BookingsActions.DECLINE}`,
                offer: `bookings/${BookingsActions.OFFER}`,
                setSnackbar: `snackbar/${SnackBarAction.SET}`,
            }),
            setStep: function (step) {
                if (step === 1) {
                    this.resetAlternative();
                    this.$v.alternativeData.$reset();
                }
                this.activeElementStep = step;
            },
            confirmBooking: function () {
                this.$refs.confirm.open(
                    this.$t("action.confirm"),
                    `<p>${this.$t("bookings.action.confirmEnquiryDialog")}</p>`,
                    {
                        confirmOptionLabel: this.$t('action.confirm')
                    }
                ).then(
                    confirmed => {
                        if(confirmed){
                            this.confirm({
                                bookingNumber: this.booking.bookingNumber
                            }).then(() => {
                                this.handleResponse('Successfully confirmed', SnackBarTypes.SUCCESS);
                            }).catch(() => {
                                this.setSnackbar({
                                    data: 'A error occurred while confirming the booking, please try again later',
                                    type: SnackBarTypes.ERROR,
                                });
                            });
                        }
                    }
                )
            },
            declineBooking: function () {
                this.$refs.confirm.open(
                    this.$t("action.decline"),
                    `<p>${this.$t("bookings.action.declineEnquiryDialog")}</p>`,
                    {
                        confirmOptionLabel: this.$t('action.decline')
                    }
                ).then(
                    confirmed => {
                        if(confirmed) {
                            this.decline({
                                bookingNumber: this.booking.bookingNumber
                            }).then(() => {
                                this.handleResponse('Successfully declined', SnackBarTypes.SUCCESS);
                            }).catch(() => {
                                this.setSnackbar({
                                    data: 'A error occurred while declining the booking, please try again later',
                                    type: SnackBarTypes.ERROR,
                                });
                            });
                        }
                    }
                )
            },
            sendOffer: function () {
                this.$v.alternativeData.$touch();
                if (false === this.$v.alternativeData.$invalid) {
                    let alternativeData = Object.assign({}, this.alternativeData);
                    if(!this.isSurcharge) {
                        alternativeData.offerPrice = -alternativeData.offerPrice;
                    }

                    this.offer({
                        offer: alternativeData,
                        bookingNumber: this.booking.bookingNumber
                    }).then(() => {
                        this.handleResponse('Successfully sent the offer', SnackBarTypes.SUCCESS);
                    }).catch(() => {
                        this.setSnackbar({
                            data: 'A error occurred while sending the offer, please try again later',
                            type: SnackBarTypes.ERROR,
                        });
                    });
                }
            },
            handleResponse: function(snackbarText, snackbarType) {
                this.setSnackbar({
                    data: snackbarText,
                    type: snackbarType
                });
                this.$router.push({name: 'Enquiries'});
            },
            resetAlternative: function () {
                this.alternativeData = {
                    offerPrice: null,
                    offerDate: null,
                    comment: null,
                };
            },
            closeDateMenu: function () {
                this.menus.offerDate = false;
                this.$v.alternativeData.offerDate.$touch();
            },
        },
    }
</script>
